export const FETCH_DELETE_ROLES_REQUEST = 'FETCH_DELETE_ROLES_REQUEST'
export const FETCH_DELETE_ROLES_SUCCESS = 'FETCH_DELETE_ROLES_SUCCESS'
export const FETCH_DELETE_ROLES_FALUIRE = 'FETCH_DELETE_ROLES_FALUIRE'
